export const takeDatepickerPlaceholderByCulture = (culture: string) => {
  if (culture.startsWith('es')) {
    return {
      placeholderPattern: 'd-`m-`A',
      placeholderYearChar: 'A',
      placeholderFormat: 'DD-MM-AAAA'
    };
  }

  if (culture.startsWith('pt')) {
    return {
      placeholderPattern: 'd/`m/`A',
      placeholderYearChar: 'A',
      placeholderFormat: 'DD/MM/AAAA'
    };
  }

  if (culture.startsWith('en')) {
    return {
      placeholderPattern: 'm/`d/`Y',
      placeholderYearChar: 'Y',
      placeholderFormat: 'MM/DD/YYYY'
    };
  }

  return {
    placeholderPattern: 'd/`m/`Y',
    placeholderYearChar: 'Y',
    placeholderFormat: 'DD/MM/YYYY'
  };

};
